import { useContext } from 'react';

import restaurantContext from 'contexts/restaurantContext';

function useRestaurant() {
  return useContext(restaurantContext);
}

export default useRestaurant;
